<template>
    <v-container fluid>
        <v-img
            src="@/assets/sponsors/MAIN.JPG" 
            class="landing-img"
        >
            <div class="landing-container">
                <div class="title">Drive Us to Action</div>
                <div class="subtitle">Sponsor MSC</div>
                <p>
                    Our goals would not be possible without our generous sponsors.
                    The institutions below allow the students of McMaster Solar Car
                    Project to pursue learning about and promoting sustainable technology.
                    If you are interested in supporting our journey, please don't hesitate
                    to contact us at macsolarcar@gmail.com.
                </p>
                <v-btn rounded class="package-button" color=#A51C21 href="sponsorship_package.pdf" target="_blank">
                    <span class="text">SPONSORSHIP PACKAGE</span>
                </v-btn>
            </div>
        </v-img>


        <div class="subheading-container">
            <h2 class="subheading" style="color: #5f86b8;">Sponsors</h2>
        </div>
        <div class="cards-container">
            <div class="cards">
                <SponsorCard
                    class="sponsor-card"
                    color=#009425
                    type="premium"
                    url="https://www.fabris.com/"
                >
                    <template v-slot:img>
                        <img src="@/assets/sponsors/fabris.webp" eager/>
                    </template>
                    <template v-slot:desc>
                        <div class="desc">
                            <p>FABRIS Inc. is a privately held, Canadian company located in Stoney Creek, Ontario on prime land in the Golden Horseshoe between Hamilton and Niagara Falls. Housed within a 80,000 square foot facility, Fabris uses the latest manufacturing techniques which allows us to be very competitive in our market segments. Our proximity to major transportation systems ensures that delivery demands can be met in a timely manner.</p>
                            <p>For over 50 years we have been perfecting and fine-tuning our products. Our accumulated knowledge and expertise in the global marketplace have allowed us to make innovative contributions to the industry, dramatically increasing efficiency and profits. Along with exemplary customer service, FABRIS has sustained growth and success by investing in expanded facilities, cutting edge equipment, technology and a highly skilled team that is fully supported by in-house training.</p>
                        </div>
                    </template>
                </SponsorCard>

                <SponsorCard
                    class="sponsor-card"
                    color=#009425
                    type="premium"
                    url="https://www.elliottmachinery.com/"
                >
                    <template v-slot:img>
                        <img src="@/assets/sponsors/elliottMatsuura.webp" eager/>
                    </template>
                    <template v-slot:desc>
                        <div class="desc">
                            <p>Our proud manufacturing history began over 100 years ago in 1905 when German Engineer, Hugo Frye, opens a precision manufacturing company in London, UK. In 1950 the B. Elliott (Canada) Ltd. opened its doors in Port Hope, Ontario. Elliott Canada started to import and distribute machine tools made in Europe. Elliott was one of the first Canadian companies to sell NC machines.</p>
                            <p>We proudly employ 90 full time staff members and sell exclusively across Canada 20 of the "best in class" portfolio of complementary machine brands. Elliott services are recognized as unequalled in the industry. Elliott provides affordable solutions to meet specific customer manufacturing needs through creative financing and dedicated support.</p>
                        </div>
                    </template>
                </SponsorCard>
                <SponsorCard
                    class="sponsor-card"
                    color=#009425
                    type="premium"
                    url="https://msumcmaster.ca/"
                >
                    <template v-slot:img>
                        <img class="logo" src="@/assets/sponsors/msu.webp" eager/>
                    </template>
                    <template v-slot:desc>
                        <div class="desc">
                            <p>The McMaster Students Union (MSU), is the largest group on campus representing approximately 27,000 undergraduate students at McMaster University. All students enrolled in 18 (or more) units are members of the MSU.</p>
                            <p>The MSU serves students in two main areas; political representation and the enhancement of student life.</p>
                            <p>The MSU operates more than two dozen different services to serve the needs of students. As well, the MSU is the front line of student advocacy. The MSU advocates for student interests at the university, municipal, provincial and federal levels of government.</p>
                        </div>
                    </template>
                </SponsorCard>
                <SponsorCard
                    class="sponsor-card"
                    color=#009425
                    type="premium"
                    url="https://www.mitutoyo.com/"
                >
                    <template v-slot:img>
                        <img width="250px" src="@/assets/sponsors/mitutoyo.svg" eager/>
                    </template>
                    <template v-slot:desc>
                        <div class="desc">
                            <p>Mitutoyo America Corporation is a sales, marketing, and most importantly, a service organization that was established in the United States in 1963 by Mitutoyo Corporation. Since day one of operations, supporting customers has been the first priority. Initially we provided replacement parts and repair services, but as our customer base grew, so did customer service demands. In response we built one of the highest performance A2LA Accredited Calibration Laboratory's (A2LA Certificate #0750.01) in the nation. Now we offer turnkey metrology solutions and even integrate measuring directly into manufacturing processes via inline automation. Mitutoyo America is also the first service organization to have A2LA Accredited Field Service Technicians</p>
                        </div>
                    </template>
                </SponsorCard>
                <SponsorCard
                    class="sponsor-card"
                    color=#009425
                    type="premium"
                    url="https://ledab.ca/"
                >
                    <template v-slot:img>
                        <img class="logo" width="150px" src="@/assets/sponsors/LeDab Bee Graphic-2.png" eager/>
                    </template>
                    <template v-slot:desc>
                        <div class="desc">
                            <p>LeDAB was founded in 2014 with the goal of being the #1 extraction equipment and solvent provider in Canada. We focus on selling high-quality products at competitive prices. </p>
                            <p>We pride ourselves on superior customer service and being extremely knowledgeable about the products we carry.</p>
                        </div>
                    </template>
                </SponsorCard>
                <SponsorCard
                    class="sponsor-card"
                    color=#009425
                    type="premium"
                    url="https://www.altium.com/"
                >
                    <template v-slot:img>
                        <img class="logo" width="150px" src="@/assets/sponsors/Alitium.svg" eager/>
                    </template>
                    <template v-slot:desc>
                        <div class="desc">
                            <p>Altium provides professional tools for electronics and PCB development. At the core is Altium Designer, where engineers do schematic capture and PCB layout with a rules-driven workflow, 3D visualization, and the outputs needed for fabrication and assembly. Around that, Altium also offers connected workflows through Altium 365 to make it easier to share designs, review and comment in context, keep version clarity, and support a cleaner handoff to manufacturing when those capabilities are useful.</p>                        </div>
                    </template>
                </SponsorCard>
                <SponsorCard
                    class="sponsor-card"
                    color=#009425
                    type="premium"
                    url="https://www.solidworks.com/"
                >
                    <template v-slot:img>
                        <img width="250px" src="@/assets/sponsors/solidworks.svg" eager/>
                    </template>
                    <template v-slot:desc>
                        <div class="desc">
                            <p>For more than 30 years, SOLIDWORKS has empowered generations of designers and engineers to create, innovate, and launch their careers. Now students can get started for free with SOLIDWORKS Design Standard - the same professional 3D CAD software trusted by leading companies around the world.</p>
                            <p>Build real-world skills, earn industry-recognized certifications, create an impressive portfolio, and prepare for the career you've always imagined.</p>
                        </div>
                    </template>
                </SponsorCard>
                <SponsorCard
                    class="sponsor-card"
                    color=#009425
                    type="premium"
                    url="https://www.vr3.ca/"
                >
                    <template v-slot:img>
                        <img width="150px" src="@/assets/sponsors/v3.png" eager/>
                    </template>
                    <template v-slot:desc>
                        <div class="desc">
                            <p>VR3 Engineering specializes in custom and prototype development projects, offering services such as CNC tube notching, tube bending, welding, and engineering support. They cater to various industries including aviation, performance racing, and architecture, providing precise and efficient solutions for both individual and collegiate projects. Their products are designed for remarkable accuracy and are ready for welding upon delivery, significantly reducing assembly times and waste. With a focus on customer satisfaction, VR3 Engineering collaborates with over 200 educational institutions and numerous manufacturers to deliver high-quality tubular structures.</p>
                        </div>
                    </template>
                </SponsorCard>

                <SponsorCard class="sponsor-card" color=#009425 type="premium" url="https://www.nomura.com/">
                    <template v-slot:img>
                        <img src="@/assets/sponsors/1200px-Nomura_logo.svg.png" eager width="280px" height="50px"/>
                    </template>
                    <template v-slot:desc>
                        <div class="desc">
                            <p>Nomura is a global financial services group with an integrated network spanning approximately 30 countries and regions. By connecting markets East & West, we service the needs of individuals, institutions, corporates and governments through our three business divisions: Wealth Management, Investment Management and Wholesale (Global Markets and Investment Banking).</p>
                        </div>
                    </template>
                </SponsorCard>

                <SponsorCard class="sponsor-card" color=#009425 type="premium" url="https://tires.bridgestone.com/en-ca/index">
                    <template v-slot:img>
                        <img width="250px" src="@/assets/sponsors/bridgestone.svg" eager/>
                    </template>
                    <template v-slot:desc>
                        <div class="desc">
                            <p>Bridgestone is a world leader in developing innovative tire technologies. Our continuous investment in research and development has led to cutting-edge new products. This includes winter tires with enhanced bite and impressive grip, fuel-efficient tires that enhance fuel economy, and safety innovations like our next-generation run-flat tires.</p>
                        </div>
                    </template>
                </SponsorCard>

                <SponsorCard class="sponsor-card" color=#009425 type="premium" url="https://alumco.net/">
                    <template v-slot:img>
                        <img src="@/assets/sponsors/alumco.png" eager/>
                    </template>
                    <template v-slot:desc>
                        <div class="desc">
                            <p>At Alumco, we have over 50 years of aluminum foundry experience. We are a company that is focused on continuous quality improvement and exceeding our customers expectations.</p>
                            <p>We strive to work closely with our customers ensuring the relationship is both informative and efficient.</p>
                        </div>
                    </template>
                </SponsorCard>

                <SponsorCard class="sponsor-card" color=#009425 type="premium" url="https://archocell.ca/">
                    <template v-slot:img>
                        <img src="@/assets/sponsors/archoshell.png" eager width="280px" height="50px"/>
                    </template>
                    <template v-slot:desc>
                        <div class="desc">
                            <p>At Archocell, our story originates from an unwavering passion for green energy and a shared belief in its transformative potential. We are a close-knit team of three young engineers who embarked on our journey by pioneering small-scale electrical vehicles such as e-bikes and longboards. As our expertise evolved and our horizons broadened, so did our ambitions, leading us to tackle larger and more impactful projects in the green energy sector.</p>
                        </div>
                    </template>
                </SponsorCard>

                <SponsorCard class="sponsor-card" color=#009425 type="premium" url="https://www.telosmfg.ca/">
                    <template v-slot:img>
                        <img src="@/assets/sponsors/Telos_Logo.png" eager width="280px" height="auto"/>
                    </template>
                    <template v-slot:desc>
                        <div class="desc">
                            <p>Telos Manufacturing specializes in the creative use of materials to solve challenging problems and bring ideas into reality. We offer CNC Routing, CNC Milling, CNC Plasma, Machining, Design, Fabrication, and Assembly Services.</p>
                        </div>
                    </template>
                </SponsorCard>

                <SponsorCard class="sponsor-card" color=#009425 type="premium" url="https://www.appliedprecision.ca/">
                    <template v-slot:img>
                        <img src="@/assets/sponsors/AppliedPrecision.jpg" eager width="280px" height="80px"/>
                    </template>
                    <template v-slot:desc>
                        <div class="desc">
                            <p>Applied Precision is on the cutting edge of 3D. From troubleshooting production on small products, replicating designs and dimensions of commercial structures, to digitizing entire workplaces to create astonishing new Augmented Reality shared spaces, our technology will help you and your company hit deadlines, solve problems and save money.</p>
                        </div>
                    </template>
                </SponsorCard>

                <SponsorCard class="sponsor-card" color=#009425 type="premium" url="https://www.maxeon.com/">
                    <template v-slot:img>
                        <img src="@/assets/sponsors/maxeon-logo.svg" eager width="280px" height="70px"/>
                    </template>
                    <template v-slot:desc>
                        <div class="desc">
                            <p>We are the global leader in solar innovation. Built from 35 years of boundary-pushing solar DNA, Maxeon Solar Technologies was launched in 2020 as an independent company following its spin-off from US-based SunPower Corporation.</p>
                            <p>Maxeon Solar Technologies designs, manufactures and sells advanced SunPower and Maxeon branded solar panels to customers in more than 100 countries worldwide, through a global network of more than 1,700 sales and installation partners.</p>
                        </div>
                    </template>
                </SponsorCard>

                <SponsorCard class="sponsor-card" color=#009425 type="premium" url="https://www.ldatech.com/">
                    <template v-slot:img><img src="@/assets/sponsors/LDA_Technologies_Logo.jpg" eager width="250px" height="80px"/></template>
                    <template v-slot:desc><div class="desc">
                        <p>LDA leads the way in high-performance, ultra-low latency FPGA and networking solutions with one of the largest product families available.</p>
                        <p>Proudly Canadian-made, our devices and IPs offer some of the lowest latencies and enhanced efficiency in the industry, continually delivering cutting-edge products with unmatched performance and reliability.</p></div></template>
                </SponsorCard>

                <SponsorCard class="sponsor-card" color=#009425 type="premium" url="https://www.tesla.com/">
                    <template v-slot:img><img src="@/assets/sponsors/tesla.png" eager width="150px" height="100px"/></template>
                    <template v-slot:desc><div class="desc"><p>We're building a world powered by solar energy, running on batteries and transported by electric vehicles. Explore the most recent impact of our products, people and supply chain.</p></div></template>
                </SponsorCard>

                <SponsorCard class="sponsor-card" color=#009425 type="premium" url="https://www.generac.com/">
                    <template v-slot:img><img src="@/assets/sponsors/generac.png" eager width="250px" height="80px"/></template>
                    <template v-slot:desc><div class="desc"><p>Founded in 1959, Generac was the first to engineer affordable home standby generators, along with the first engine developed specifically for the rigors of generator use, and is now the #1 manufacturer of home backup generators. Generac manufactures the widest range of power products in the marketplace including portable, residential, commercial and industrial generators.</p></div></template>
                </SponsorCard>

                <SponsorCard class="sponsor-card" color=#009425 type="premium" url="https://www.ecobee.com/en-us/">
                    <template v-slot:img><img src="@/assets/sponsors/ecobee.png" eager width="250px" height="90px"/></template>
                    <template v-slot:desc><div class="desc">
                        <p>ecobee was founded with the goal of offering people smart home solutions that enable planet positive actions. We've made a lot of progress since then, but there's still more work left to do. We need your help because the more we grow, the greener things get.</p>
                        <p>To date, ecobee thermostats have delivered over 53.9 TWh of energy savings. That's like taking all the homes in New York and Los Angeles off the grid or 2.4 million gas-powered cars off the road for a year. </p>
                </div></template>
                </SponsorCard>

                <SponsorCard class="sponsor-card" color=#009425 type="premium" url="https://www.pvsyst.com/en/">
                    <template v-slot:img><img src="@/assets/sponsors/pvsyst.png" eager width="250px" height="80px"/></template>
                    <template v-slot:desc><div class="desc"><p>PVsyst is the leading software for the design, simulation and analysis of photovoltaic systems. Used by architects, engineers and researchers worldwide, our objective is to provide precise tools to optimise solar energy production and ensure the success of your projects.</p></div></template>
                </SponsorCard>

                <SponsorCard class="sponsor-card" color=#009425 type="premium" url="https://www.magna.com/">
                    <template v-slot:img><img src="@/assets/sponsors/magna.jpg" eager width="250px" height="80px"/></template>
                    <template v-slot:desc><div class="desc"><p>Magna is one of the world's largest automotive suppliers and a trusted partner to automakers in the industry's most critical markets—North America, Europe, and China. With operations in 28 countries, we combine global scale with trusted reliability and proven execution. Backed by nearly seven decades of experience, we bring together deep manufacturing expertise with innovative vehicle systems to deliver performance, safety, and quality.</p></div></template>
                </SponsorCard>

                <SponsorCard class="sponsor-card" color=#009425 type="premium" url="https://fibre-lam.com/">
                    <template v-slot:img>
                        <img src="@/assets/sponsors/FibreLam.webp" eager/>
                    </template>
                    <template v-slot:desc>
                        <div class="desc">
                            <p>Fibre Laminations Ltd. has evolved from a more than 5 decade old pledge to strive for excellence in the creation and development of quality fibre-reinforced plastics/composites for a variety of applications within today's automotive, medical, marine, recreation, power generation and construction industries.</p>
                        </div>
                    </template>
                </SponsorCard>

                <SponsorCard class="sponsor-card" color=#009425 type="premium" url="https://www.voestalpine.com/group/en/">
                    <template v-slot:img><img src="@/assets/sponsors/voestalpine.svg" eager width="250px" height="80px"/></template>
                    <template v-slot:desc><div class="desc"><p>voestalpine is a globally leading steel and technology group with a unique combination of materials and processing expertise. voestalpine, which operates globally, has around 500 Group companies and locations in more than 50 countries on all five continents. The voestalpine Group has been listed on the Vienna Stock Exchange since 1995. With its premium products and system solutions, voestalpine is a leading partner to the automotive and machinery industries, as well as to the aerospace and energy industries. </p></div></template>
                </SponsorCard>

                <SponsorCard class="sponsor-card" color=#009425 type="premium" url="https://gochermann.com/">
                    <template v-slot:img><img src="@/assets/sponsors/gst.png" eager width="250px" height="80px"/></template>
                    <template v-slot:desc><div class="desc"><p>Gochermann Solar Technology is a manufacturer of custom solar arrays with very special features required in solar race events such as the Australian World Solar Challenge and other events around the globe, powering cars, boats and airplanes. Our arrays meet all requirements with respect to optical, mechanical, and electrical properties.</p></div></template>
                </SponsorCard>

                <SponsorCard class="sponsor-card" color=#009425 type="premium" url="https://www.appliedintuition.com/">
                    <template v-slot:img><img src="@/assets/sponsors/applied.png" eager width="250px" height="80px"/></template>
                    <template v-slot:desc><div class="desc"><p>We're creating a future where every moving machine, from ships and satellites to trucks and robots, is infused with intelligence. We have the expertise, global reach, trusted leaders, resources, and strategic partners to match any ambition.</p></div></template>
                </SponsorCard>

                <SponsorCard class="sponsor-card" color=#009425 type="premium" url="https://macengsociety.ca/">
                    <template v-slot:img><img src="@/assets/sponsors/mes.png" eager width="250px" height="80px"/></template>
                    <template v-slot:desc><div class="desc"><p>The McMaster Engineering Society (MES) is the official undergraduate McMaster University Faculty of Engineering student society. We are a group of students who work to foster the development of our fellow classmates by offering professional, conference, academic, athletic, social, wellness, and mentorship opportunities!</p></div></template>
                </SponsorCard>

            </div>
        </div>
    </v-container>
</template>

<script>
import SponsorCard from "@/components/SponsorCard.vue";

export default {
    name: "Sponsors",
    components: {
        SponsorCard
    }
}
</script>

<style lang="scss" scoped>
.landing-img {
    .landing-container {
        background-color: #0000007a;
        padding: 50px;
        font-size: 20px;
        font-weight: 800;
        margin-top: 50px;
        margin-bottom: 50px;
        color: rgb(255, 255, 255);
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        text-shadow: 2px 2px 2px #000000;
        
        .title {
            font-weight: 400;
            font-size: 25px !important;
        }

        .subtitle {
            color: #FBB514;
            font-weight: 400;
        }

        p {
            text-align: center;
            max-width: 600px;
            width: 80%;
        }

        .package-button {
            margin-top:5%;
            height: 43px;
            .text {
                text-shadow: none;
                color:white;
                font-weight: 300;
            }
        }
    }
}

.subheading-container {
    border: red;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 15px;
    .subheading {
        font-weight: 300;
        padding: 10px 50px 10px 50px;
        background-color: #ffffff14;
    }
}

.cards-container {
    display: flex;
    justify-content: center;
    .cards {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        margin-top: 50px;
        margin-bottom: 50px;
        max-width: 1500px;
        
        .card {
            $margin: 30px;
            margin: 10px $margin 10px $margin;
        }
    }
}
</style>